export default {
    decklist: 'Decklist',
    results: 'Search Results'
};